import axios from "axios";

export const LOGIN_URL = `/v2/account/login`;
export const REGISTER_URL = "/v2/user/register";
export const REQUEST_PASSWORD_URL = `/v2/account/forgot`;
export const RESET_PASSWORD_URL = `/v2/account/reset`;
export const ME_URL = `/v2/account/me`;
export const UPDATE_USER_URL = "/v2/user/update/";
export const CHANGE_PASSWORD_URL = "/v2/account/changepassword";

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function register(values) {
  return axios.post(REGISTER_URL, { ...values });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function resetPassword(token, password) {
  return axios.post(`${RESET_PASSWORD_URL}/${token}`, { password });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}

export function updateUser(value) {
  return axios.put(`${UPDATE_USER_URL}${value && value._id}`, { ...value });
}

export function changePassword(value) {
  return axios.post(CHANGE_PASSWORD_URL, { ...value });
}

export function updateNotificationSettings(value) {
  return axios.post(`/v2/settings/${value.userId}`, { ...value });
}
